import React from 'react';

const SvgComputerCircle = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    aria-hidden="true"
    width={props.width || 52}
    height={props.height || 52}
    viewBox="0 0 52 52"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect x={1} y={1} width={50} height={50} rx={25} fill="currentColor" />
    <rect x={1} y={1} width={50} height={50} rx={25} stroke="currentColor" strokeWidth={2} />
    <path
      d="M22.7515 26.2648C23.064 26.5578 23.5705 26.5578 23.883 26.2648L24.4485 25.7347C24.761 25.4417 24.761 24.9669 24.4485 24.6739L22.6625 23L24.448 21.3256C24.7605 21.0327 24.7605 20.5578 24.448 20.2648L23.8825 19.7347C23.57 19.4417 23.0635 19.4417 22.751 19.7347L19.834 22.4694C19.5215 22.7623 19.5215 23.2372 19.834 23.5302L22.7515 26.2648ZM27.552 25.7352L28.1175 26.2653C28.43 26.5583 28.9365 26.5583 29.249 26.2653L32.166 23.5306C32.4785 23.2377 32.4785 22.7628 32.166 22.4698L29.249 19.7352C28.9365 19.4422 28.43 19.4422 28.1175 19.7352L27.552 20.2653C27.2395 20.5583 27.2395 21.0331 27.552 21.3261L29.3375 23L27.552 24.6744C27.2395 24.9673 27.2395 25.4422 27.552 25.7352ZM41.2 33.5H29.077C29.04 34.4286 28.3415 35 27.44 35H24.4C23.4655 35 22.749 34.1811 22.7615 33.5H10.8C10.36 33.5 10 33.8375 10 34.25V35C10 36.65 11.44 38 13.2 38H38.8C40.56 38 42 36.65 42 35V34.25C42 33.8375 41.64 33.5 41.2 33.5ZM38.8 16.25C38.8 15.0125 37.72 14 36.4 14H15.6C14.28 14 13.2 15.0125 13.2 16.25V32H38.8V16.25ZM35.6 29H16.4V17H35.6V29Z"
      fill="white"
    />
  </svg>
);
export default SvgComputerCircle;
